
import axios from 'axios';


const Toolbox = {








/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* *******************************          Toolbox Helper   ************************************************/



findElementByClassOrTag: (button, classelement, tagname = null) => {
  let foundelement = null;

  // Suche zuerst nach Geschwisterelementen
  let siblingElement = button.nextElementSibling;
  while (siblingElement) {
    if ((tagname && siblingElement.tagName.toLowerCase() === tagname.toLowerCase() && siblingElement.classList.contains(classelement)) || (!tagname && siblingElement.classList.contains(classelement))) {
      foundelement = siblingElement;
      break;
    }
    siblingElement = siblingElement.nextElementSibling;
  }

  // Wenn kein Geschwisterelement gefunden wurde, suche in den Eltern-Containern
  if (!foundelement) {
    let parentElement = button.parentElement;
    while (parentElement) {
      if ((tagname && parentElement.tagName.toLowerCase() === tagname.toLowerCase() && parentElement.classList.contains(classelement)) || (!tagname && parentElement.classList.contains(classelement))) {
        foundelement = parentElement;
        break;
      }
      parentElement = parentElement.parentElement;
    }
  }

  return foundelement;
}


  // Weitere Funktionen für Toolbox hier hinzufügen...
};





export default Toolbox;